import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58cfff1e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfff1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cfff1e')) {
      api.createRecord('58cfff1e', component.options)
    } else {
      api.reload('58cfff1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58cfff1e&scoped=true", function () {
      api.rerender('58cfff1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/ordinary/index.vue"
export default component.exports